import { render, staticRenderFns } from "./LectorsDetails.vue?vue&type=template&id=2012b5c0&scoped=true"
import script from "./LectorsDetails.vue?vue&type=script&lang=js"
export * from "./LectorsDetails.vue?vue&type=script&lang=js"
import style0 from "./LectorsDetails.vue?vue&type=style&index=0&id=2012b5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012b5c0",
  null
  
)

export default component.exports